import { render, staticRenderFns } from "./SelectorTipoProdutoList.vue?vue&type=template&id=6b2eb427&scoped=true"
import script from "./SelectorTipoProdutoList.vue?vue&type=script&lang=js"
export * from "./SelectorTipoProdutoList.vue?vue&type=script&lang=js"
import style0 from "./SelectorTipoProdutoList.vue?vue&type=style&index=0&id=6b2eb427&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2eb427",
  null
  
)

export default component.exports